/** Extensions FC2 treats as part of a permit submission package. */
const SUBMISSION_EXTENSIONS = new Set([
  ".rvt",
  "rvt",
  ".pdf",
  "pdf",
  ".dwg",
  "dwg",
]);

export function normalizeExtension(ext: string | undefined): string {
  if (!ext) return "";
  const lower = ext.toLowerCase();
  return lower.startsWith(".") ? lower : `.${lower}`;
}

export function isSubmissionFileExtension(ext: string | undefined): boolean {
  const n = normalizeExtension(ext);
  return SUBMISSION_EXTENSIONS.has(n) || SUBMISSION_EXTENSIONS.has(n.slice(1));
}

export function isRevitExtension(ext: string | undefined): boolean {
  const n = normalizeExtension(ext);
  return n === ".rvt";
}

export function isPdfExtension(ext: string | undefined): boolean {
  return normalizeExtension(ext) === ".pdf";
}
